<div class="modal">
  <div class="card">
    <div class="card-body">
      <div class="row">
        <div class="col-12">
          <div class="form-group mb-0">
            <label class="form-label">Dokument</label>
            <div class="custom-file">
              <input type="file" 
                     multiple 
                     class="custom-file-input" 
                     name="file"
                     (change)="handleFileChange($event)">
              <label class="custom-file-label">Izaberi dokument</label>
            </div>

            <div class="links mt-20" *ngIf="uploadedFiles && uploadedFiles.length > 0">
              <div *ngFor="let file of uploadedFiles; let i = index">
                <div class="d-flex justify-content-between align-content-center">
                  <div class="d-flex">
                    <i class="fa fa-link mt-1 mr-3"></i>
                    <p>{{ file.name }}</p>
                  </div>
                  <app-delete (selected)="onRemoveFile(i)"></app-delete>
                </div>
              </div>
            </div>
          </div>
          <div *ngIf="calculateFilesSize()" [class.text-red]="calculateFilesSize()?.tooBig">* Veličina dokumenata koje ste učitali je: {{ calculateFilesSize().size }}</div>
        </div>
      </div>
    </div>
    <div class="card-footer text-right">
      <button class="btn btn-secondary btn-question mr-2" (click)="emitFalse()">Nazad</button>
      <button class="btn btn-success btn-question" (click)="emitTrue()" [class.disabled]="calculateFilesSize()?.tooBig">Pošalji</button>
    </div>
  </div>
</div>
